import { render, staticRenderFns } from "./LocalNotifierDisplay.vue?vue&type=template&id=f196f648&"
import script from "./LocalNotifierDisplay.vue?vue&type=script&lang=js&"
export * from "./LocalNotifierDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports